import { render } from "./PlanPurchaseTab.vue?vue&type=template&id=464c0ea3&scoped=true"
import script from "./PlanPurchaseTab.vue?vue&type=script&lang=js"
export * from "./PlanPurchaseTab.vue?vue&type=script&lang=js"

import "./PlanPurchaseTab.vue?vue&type=style&index=0&id=464c0ea3&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464c0ea3"]])

export default __exports__